import { render } from "./ChooseEvaluationModal.vue?vue&type=template&id=564671d1&scoped=true"
import script from "./ChooseEvaluationModal.vue?vue&type=script&lang=js"
export * from "./ChooseEvaluationModal.vue?vue&type=script&lang=js"

import "./ChooseEvaluationModal.vue?vue&type=style&index=0&id=564671d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564671d1"]])

export default __exports__